import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { Divider, Flex, Loading, Text } from "@paguelofacil/pf-components";

import zinliImage from "../assets/images/zinli.png";
import LogoCryptofacil from "../assets/images/logo-cryptofacil.png";
import { STEPS, STEPS_CRYPTO_PAYMENT } from "../services/utils/Constants";
import { ManageService } from "../services/Services";
import { language, languageDefault } from "../services/utils/Language";
import useStore from "../services/store/useStore";
import { useRedirectWithoutSession } from "../hooks/useRedirectWithoutSession";

import CryptoSdk from "../components/CryptoSdk";
import PaymentSdkForm from "../components/PaymentSdkForm";
import { HeaderPayment } from "../components/HeaderPayment";
import { ButtonBack } from "../components/ButtonBack";
import { ConnectAccount } from "../components/ConnectAccount";
import PaymentAmount from "../components/PaymentAmount";
import ValidateStatusKyc from "../components/ValidateStatusKyc";
import AppWithErrorBoundary from "../components/Error/ErrorBoudary";

import "../assets/scss/containers.scss";

const dictionaryTitleByStep = currentStepCrypto => ({
    PRE_CONNECT_ACCOUNT: (
        <FormattedMessage id={language.first_step_title} defaultMessage={languageDefault.first_step_title} />
    ),
    CRYPTO:
        STEPS_CRYPTO_PAYMENT.COIN_NETWORK === currentStepCrypto.ref ? (
            <FormattedMessage id={language.second_step_title} defaultMessage={languageDefault.second_step_title} />
        ) : (
            <FormattedMessage
                id={language.second_step_title_details_crypto}
                defaultMessage={languageDefault.second_step_title_details_crypto}
            />
        ),
    LOGIN: <FormattedMessage id={language.back_to_init} defaultMessage={languageDefault.back_to_init} />,
    STATUS_KYC_CRYPTOFACIL: (
        <FormattedMessage id={language.kyc_step_title} defaultMessage={languageDefault.kyc_step_title} />
    ),
    AMOUNT: <></>,
    SCAN_QR: <></>,
    LOADING_DATA: <></>,
    CREATE_ACCOUNT: <></>,
    VALIDATE_CODE: <></>,
});

const ZinliContainer = ({ intl }) => {
    useRedirectWithoutSession();
    const navigate = useNavigate();
    //setters
    const { setMaxAmountZinli, setCurrentStepZinli, setCurrentStepCrypto } = useStore(state => state);
    //estados
    const { maxAmountZinli, currentStepZinli, user, currentStepCrypto, hideTitleCrypto } = useStore(state => state);

    useEffect(() => {
        if (user?.zinliData?.email && user?.zinliData?.phone) {
            return handlePaymentForm(user?.zinliData?.email, user?.zinliData?.phone);
        }
        return initPreConnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.zinliData?.email, user?.zinliData?.phone]);

    const setCurrentStep = step => {
        setCurrentStepZinli(step);
    };

    const getInfoZinli = ref => {
        ManageService.accountInfo().then(response => {
            if (response) {
                setCurrentStep({
                    ...currentStepZinli,
                    data: {
                        cclw: response.cclw,
                        apiKey: response.apiKey,
                        ...currentStepZinli.data,
                    },
                    ref,
                });
                setMaxAmountZinli(parseFloat(response.maxAmountZinli));
            }
        });
    };

    const initPreConnect = () => {
        setCurrentStep({
            ...currentStepZinli,
            ref: STEPS.PRE_CONNECT_ACCOUNT,
        });
        getInfoZinli(STEPS.PRE_CONNECT_ACCOUNT);
    };

    const handleConnectAccount = () => {
        setCurrentStep({
            ...currentStepZinli,
            ref: STEPS.LOGIN,
            data: {
                ...currentStepZinli.data,
            },
        });
    };

    const handlePaymentForm = (email, phone) => {
        let newStep = {
            ...currentStepZinli,
            ref: STEPS.STATUS_KYC_CRYPTOFACIL,
            data: {
                ...currentStepZinli.data,
                email: email,
                phone: phone,
            },
        };
        setCurrentStep(newStep);
        getInfoZinli(STEPS.STATUS_KYC_CRYPTOFACIL);
    };

    const handleStepVerificated = () => {
        setCurrentStep({
            ...currentStepZinli,
            ref: STEPS.AMOUNT,
        });
    };

    const handlePaymentAmountForm = amount => {
        let newStep = {
            ...currentStepZinli,
            ref: STEPS.CRYPTO,
            data: {
                ...currentStepZinli.data,
                amount: amount,
            },
        };

        setCurrentStepCrypto({
            ref: STEPS_CRYPTO_PAYMENT.COIN_NETWORK,
            data: {},
        });

        setCurrentStep(newStep);
    };

    const handleBack = stepToBack => {
        let newStep = {
            ...currentStepZinli,
            ref: stepToBack,
            data: {
                ...currentStepZinli.data,
            },
        };
        setCurrentStep(newStep);
    };

    return (
        <AppWithErrorBoundary>
            <Loading isLoading={STEPS.LOADING_DATA === currentStepZinli.ref}>
                <Flex direction="column" width="auto" minW="auto" className="container-payment">
                    <Flex gap="0.25rem" wrap="nowrap">
                        <img src={LogoCryptofacil} alt="logo cryptofacil" className="img-cryptofacil-card-payment" />
                        <Divider orientation="vertical" height="1px" width="1.5rem" />
                        <img src={zinliImage} alt="logo zinli" className="img-zinli-card-payment" />
                    </Flex>
                    <HeaderPayment
                        title={
                            STEPS.CRYPTO === currentStepZinli.ref || STEPS.AMOUNT === currentStepZinli.ref ? (
                                <FormattedMessage
                                    id={language.title_charge_zinli_crypto}
                                    defaultMessage={languageDefault.title_charge_zinli_crypto}
                                />
                            ) : (
                                <FormattedMessage
                                    id={language.connect_account_zinli}
                                    defaultMessage={languageDefault.connect_account_zinli}
                                />
                            )
                        }
                    />
                    {hideTitleCrypto ? (
                        <></>
                    ) : (
                        <Flex gap="0" wrap="nowrap">
                            {STEPS.AMOUNT === currentStepZinli.ref ? (
                                <></>
                            ) : STEPS.CRYPTO === currentStepZinli.ref ? (
                                <ButtonBack handleBack={() => handleBack(STEPS.AMOUNT)} />
                            ) : STEPS.STATUS_KYC_CRYPTOFACIL === currentStepZinli.ref ? (
                                <ButtonBack handleBack={() => handleBack(STEPS.LOGIN)} />
                            ) : (
                                <ButtonBack handleBack={() => navigate("/cryptofacil/home")} />
                            )}
                            <Text variant="caption" weight="regular" style={{ maxWidth: "450px" }}>
                                {dictionaryTitleByStep(currentStepCrypto)[currentStepZinli.ref] ? (
                                    dictionaryTitleByStep(currentStepCrypto)[currentStepZinli.ref]
                                ) : (
                                    <></>
                                )}
                            </Text>
                        </Flex>
                    )}
                    {STEPS.PRE_CONNECT_ACCOUNT === currentStepZinli.ref && (
                        <ConnectAccount intl={intl} handleConnectAccount={handleConnectAccount} />
                    )}
                    {STEPS.LOGIN === currentStepZinli.ref && (
                        <PaymentSdkForm intl={intl} handle={handlePaymentForm} user={user} />
                    )}
                    {STEPS.STATUS_KYC_CRYPTOFACIL === currentStepZinli.ref && (
                        <ValidateStatusKyc handleStepVerificated={handleStepVerificated} platform="ZINLI" />
                    )}
                    {STEPS.AMOUNT === currentStepZinli.ref && (
                        <PaymentAmount
                            intl={intl}
                            handle={handlePaymentAmountForm}
                            handleBack={() => handleBack(STEPS.LOGIN)}
                            hasBalance={false}
                            maxAmount={maxAmountZinli}
                        />
                    )}
                    {STEPS.CRYPTO === currentStepZinli.ref && <CryptoSdk />}
                </Flex>
            </Loading>
        </AppWithErrorBoundary>
    );
};

const ZinliContainerDecorate = injectIntl(ZinliContainer);

export default ZinliContainerDecorate;
